// ! NOTE: Primary - Used by snow brands (except Danski)
// ! NOTE: Secondary - Used by leisure and sun brands
// ! NOTE: Add new variants as needed

const variables = {
  variant: 'primary',
};

export default variables;
